import React, {Fragment, useContext} from 'react';
import PropTypes from 'prop-types';
import SavedGigs from './SavedGigs';
import {LiveGigsContext} from './LiveGigs';
import {SavedGigsContext} from './SavedGigsContext';
import {View} from './LiveGigs/View';
import {Box, Text} from 'grommet';

const GigsList = (props) => {

    const liveGigsContext = useContext(LiveGigsContext)
    const savedGigsContext = useContext(SavedGigsContext)

    const {showSavedGigsOnly} = props

    if (showSavedGigsOnly) {
        if (savedGigsContext.state.savedGigs) {
            return (<SavedGigs gigs={savedGigsContext.state.savedGigs}/>)
        } else {
            return <Box
                fill='horizontal'
            >
                <Text size='large' color='brand'>Loading gigs...</Text>
            </Box>  // TODO: Better progress indicator
        }

    } else {
        const gigs = liveGigsContext.state.liveGigs

        if (liveGigsContext.state.liveGigsLoaded) {
            if (savedGigsContext.state.savedGigs) {
                gigs.forEach((gig) => {
                    gig.isSaved = savedGigsContext.hasGig(gig.id);
                })
            }

            return (
                <View
                    gigs={gigs}
                    reload={() => liveGigsContext.reload()}
                    next={() => liveGigsContext.fetch()}
                    hasMore={liveGigsContext.state.hasMore}
                />
            )
        } else {
            return <Box
                fill='horizontal'
            >
                <Text size='large' color='brand'>Loading gigs...</Text>
            </Box>  // TODO: Better progress indicator
        }
    }
}

export default GigsList

GigsList.propTypes = {}
